import { v4 as uuidv4 } from "uuid";
import Cookies from "../../cookies";

export default function getAnonymousUserId(): string {
    let anonymousUserId = Cookies.get("anonymous_id");
    if (!anonymousUserId) {
        anonymousUserId = uuidv4();
        // Save it in cookies so landing page can use it if needed
        Cookies.set("anonymous_id");
    }

    return anonymousUserId;
}
